import { render, staticRenderFns } from "./AveragePace.vue?vue&type=template&id=f4230bee&"
import script from "./AveragePace.vue?vue&type=script&lang=ts&"
export * from "./AveragePace.vue?vue&type=script&lang=ts&"
import style0 from "./AveragePace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports